<template>
  <va-create-layout>
    <categories-form :title="title" :item="item" :is-create="true"></categories-form>
  </va-create-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
